import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { finishedProductImages } from "../data/landingContent";
const enterEase = [0.22, 1, 0.36, 1] as const;
export function FinishedProductsShowcase() {
  const reduceMotion = useReducedMotion();
  return <div className="lg:mt-0" data-id="element-71" data-mp="3ujg39z5ysxeo">
      <h3 className="text-2xl font-extrabold leading-[1.05] tracking-[-0.05em] text-[#091a37] sm:text-[28px]" data-id="element-72" data-mp="3egekr8gucq2">De la fórmula al producto terminado.</h3>
      <p className="mt-2 text-sm leading-6 text-[#526078]" data-id="element-73" data-mp="r5by712rq1m8">Algunas de las preparaciones que podés aprender a elaborar con el material.</p>
      <div className="-mx-3 mt-4 flex w-[calc(100%+24px)] items-end gap-1.5 sm:mx-0 sm:w-full sm:gap-2" aria-label="Ejemplos de productos terminados" data-id="element-74" data-mp="h6mr83ceu1kr">
        {finishedProductImages.map((product, index) => <motion.img key={product.src} src={product.src} alt={product.alt} className="min-w-0 flex-1 object-contain" initial={reduceMotion ? false : {
        opacity: 0,
        y: 10
      }} whileInView={reduceMotion ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        delay: index * 0.1,
        ease: enterEase
      }} data-id="element-75" data-mp="31wvd32186rcp" data-mpi={index} />)}
      </div>
    </div>;
}